import { environment } from 'environments/environment';

export class ProductSimple {
  public images: Array<any> = [];

  constructor(
    public id: string = '',
    public name_s: string = '',
    public slug_s: string = '',
    public price_f: number = 0,
    public locale_s: string = '',
    public product_type_s: string = '',
    public product_brand_s: string = '',
    public product_model_s: string = '',
    public published_at_dt: string = '',
    public images_url_ss: Array<string> = [],
    public images_thumbnail_url_ss: Array<string> = [],
    public images_small_url_ss: Array<string> = [],
    public country_s: string = '',
  ) {}

  bootstrap() {
    this.country_s = this.country_s.toUpperCase();
    this.images = this.images_url_ss.map((url, index) => {
      return {
        id: index,
        url: this.imagePath(url),
        thumbnailUrl: this.imagePath(this.images_thumbnail_url_ss[index]),
        smallUrl: this.imagePath(this.images_small_url_ss[index]),
        alt: this.name_s,
        title: this.name_s,
      };
    });
  }

  /*-----------------------------------------------------------------------------------
   * @ Public methods
   *-----------------------------------------------------------------------------------*/
  get link() {
    return `/marketplace/${this.slug_s}-p${this.id}`;
  }

  /**
   *
   * @param url
   * @returns
   */
  imagePath(url: string) {
    return `${environment.assets}${url}` || '';
  }
}
